import LocationUpdate from "./locationUpdate";

export default LocationUpdate;
